/* eslint-disable react/prop-types */
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import ReasonField from './ReasonField'

function TenantOperationDialog({
  open,
  operation,
  featureName,
  target,
  reason,
  onTargetChange,
  onReasonChange,
  onCancel,
  onSubmit,
}) {
  const disabled = target.trim() === '' || reason.trim() === ''

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>
        {operation === 'ADD' ? 'Adicionar tenant' : 'Remover tenant'}: {featureName}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Informe um <b>endereço de e-mail de um usuário</b> ou <b>ID do Tenant</b>.
        </DialogContentText>
        <TextField
          label="Digite um email / ID Tenant"
          value={target}
          onChange={(event) => onTargetChange(event.target.value)}
          fullWidth
          margin="normal"
          autoFocus
        />
        <ReasonField value={reason} onChange={onReasonChange} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancelar</Button>
        <Button
          variant="contained"
          color={operation === 'REMOVE' ? 'error' : 'primary'}
          disabled={disabled}
          onClick={onSubmit}
        >
          {operation === 'ADD' ? 'Adicionar' : 'Remover'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default TenantOperationDialog
